import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Button, Modal, Form } from "react-bootstrap";
import { IoMdMore } from "react-icons/io";
import Toast from "./Toast"; // <-- Import your Toast
import { API } from "../Contstant/constant";

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [formdata, setFormData] = useState({ name: "" });
  const [openRowId, setOpenRowId] = useState(null);

  // Modal states
  const [showEditModal, setShowEditModal] = useState(false);
  const [editCategory, setEditCategory] = useState({ _id: "", name: "" });
  const [showViewModal, setShowViewModal] = useState(false);

  // Toast state
  const [toast, setToast] = useState({ message: "", type: "" });

  // Fetch categories
  const fetchCategories = async () => {
    try {
      let response = await axios.get(`${API}/api/category/getdata`);
      setCategories(response.data.categories);
      setTotal(response.data.categories.length);
    } catch (error) {
      showToast("Failed to fetch categories", "error");
      console.error(error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);


  const showToast = (message, type) => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };

 
  const handleAddCategory = async () => {
    try {
      let response = await axios.post(`${API}/api/category/create`, formdata, {
        headers: { "Content-Type": "application/json" },
      });
      if (response.status === 201) {
        setCategories((prev) => [...prev, response.data.data]);
        setTotal((prev) => prev + 1);
        setFormData({ name: "" });
        showToast("Category added successfully", "success");
      }
    } catch (error) {
      showToast("Failed to add category", "error");
    }
  };

  // Delete category
  const handleDeleteSingle = async (id) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      try {
        await axios.delete(`${API}/api/category/delete/${id}`);
        setCategories((prev) => prev.filter((cat) => cat._id !== id));
        setTotal((prev) => prev - 1);
        showToast("Category deleted successfully", "success");
      } catch (error) {
        showToast("Failed to delete category", "error");
      }
    }
  };

  // Edit category
  const handleEdit = (category) => {
    setEditCategory(category);
    setShowEditModal(true);
    setOpenRowId(null);
  };

  const handleEditSubmit = async () => {
    try {
      let response = await axios.put(
        `${API}/api/category/update/${editCategory._id}`,
        { name: editCategory.name },
        { headers: { "Content-Type": "application/json" } }
      );
      if (response.status === 200) {
        setCategories((prev) =>
          prev.map((cat) => (cat._id === editCategory._id ? response.data.data : cat))
        );
        setShowEditModal(false);
        showToast("Category updated successfully", "success");
      }
    } catch (error) {
      showToast("Failed to update category", "error");
    }
  };

  // View category
  const handleView = (category) => {
    setEditCategory(category);
    setShowViewModal(true);
    setOpenRowId(null);
  };

  const columns = [
    { name: "SI No.", selector: (row, index) => index + 1, sortable: true },
    { name: "Name", selector: (row) => row.name, sortable: true },
    {
      name: "Action",
      cell: (row) => (
        <div className="cursor">
          <IoMdMore
            onClick={(e) => {
              e.stopPropagation();
              setOpenRowId((prev) => (prev === row._id ? null : row._id));
            }}
          />
          {openRowId === row._id && (
            <div className="dropdown_list">
              <p style={{ cursor: "pointer", color: "red" }} onClick={() => handleDeleteSingle(row._id)}>
                Delete
              </p>
              <p style={{ cursor: "pointer", color: "skyblue" }} onClick={() => handleView(row)}>
                View
              </p>
              <p style={{ cursor: "pointer", color: "green" }} onClick={() => handleEdit(row)}>
                Edit
              </p>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div>
      <h5>Categories</h5>
      <div className="row mb-3">
        <input
          className="col-md-7 me-auto"
          type="text"
          placeholder="Enter category name"
          value={formdata.name}
          onChange={(e) => setFormData({ ...formdata, name: e.target.value })}
        />
        <button className="col-md-4 add-btn" onClick={handleAddCategory}>
          Add Category
        </button>
      </div>

      <DataTable
        columns={columns}
        data={categories}
        pagination
        paginationServer
        paginationTotalRows={total}
        paginationPerPage={limit}
        selectableRows
        onChangePage={(page) => setPage(page)}
        onChangeRowsPerPage={(newLimit) => setLimit(newLimit)}
      />

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            type="text"
            value={editCategory.name}
            onChange={(e) => setEditCategory({ ...editCategory, name: e.target.value })}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleEditSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* View Modal */}
      <Modal show={showViewModal} onHide={() => setShowViewModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>View Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <p>
            <strong>ID:</strong> {editCategory._id}
          </p> */}
          <p>
            <strong>Name:</strong> {editCategory.name}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowViewModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Toast Notification */}
      {toast.message && <Toast message={toast.message} type={toast.type} />}
    </div>
  );
};

export default Category;